import React, { useState } from 'react';
import { Translate } from "@montana/shared/translate";
import { useTranslations } from '@montana/containers/translations';
import { useCart } from '@montana/containers/cart';
import { Spinner } from '@montana/shared/spinner/spinner.component';
import { TextInput } from '@montana/shared/form';

export const Voucher = () => {

    const { addVoucher, addingVoucher } = useCart();
    const translate = useTranslations();
    const [voucher, setVoucher] = useState('');

    return (
        <div className="voucher">
            <TextInput
                label={translate(t => t.cartPage.cartPageVoucher, '[Voucher]')}
                onChange={e => setVoucher(e.target.value)}
                optionalIndicator={false}
                onKeyUp={(event) => {
                    if(event.key.toLowerCase() === 'enter'){
                        addVoucher(voucher);
                    }
                }}
            >
                <button
                    className="voucher__button"
                    type="button"
                    onClick={() => addVoucher(voucher)}
                >
                    { addingVoucher ? (
                        <Spinner />
                    ) : (
                        <Translate value="cartPage.cartPageVoucherAdd" defaultValue="[Add]" />
                    )}
                </button>
            </TextInput>
        </div>
    );
};
